/* eslint-disable */
<template>
  <div>

    <vx-card class="mb-8">
      <!-- SEARCH BAR -->
      <vs-row vs-type="flex" >
        <vs-col vs-lg="8" vs-sm="12" vs-xs="12" >
          <vs-row  vs-type="flex" >
            <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
              <span>Nome</span>
              <vs-input
                v-model="nomeCliente"
                @keyup.enter="refine(nomeCliente, cnpjCliente, proposeDate, status)"
                @keyup.esc="refine(nomeCliente, cnpjCliente, proposeDate, status)"
                class="w-full"/>
            </vs-col>
            <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
              <span class="ml-2">Cnpj Cliente</span>
              <CnpjInput
                v-model="cnpjCliente"
                @keyup.enter="refine(nomeCliente, cnpjCliente, proposeDate, status)"
                @keyup.esc="refine(nomeCliente, cnpjCliente, proposeDate, status)"
                class="w-full" />
            </vs-col>
            <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
              <span class="ml-2">Data</span>
              <date-picker
                v-model="proposeDate"
                name="data"
                format="DD-MM-YYYY"
                value-type="YYYY-MM-DD"
                class="w-full"/>
            </vs-col>
            <vs-col vs-lg="4" vs-sm="6" vs-xs="12" class="mt-4">
              <span class="ml-2">Status</span>
              <vs-select
                v-model="status"
                @input="refine(nomeCliente, cnpjCliente, proposeDate, status)"
                class="w-full">
                <vs-select-item key="" value="" text="Todos" />
                <vs-select-item :key="item.status" :value="item.status" :text="item.statusDescription" v-for="item in statusOptions" />
              </vs-select>
            </vs-col>
          </vs-row>
        </vs-col>

        <vs-col vs-lg="4" vs-sm="12" vs-xs="12" vs-align="center" class="mt-4">
          <vs-row vs-align="center" >
            <vs-col vs-lg="5" vs-sm="5" vs-xs="12" class="mt-1">
              <vs-button class="w-full" @click="clearFilter()" icon-pack="fa" icon="fa-eraser" title="Limpar"> <span class="auto-hide-clear-text" >Limpar</span> </vs-button>
            </vs-col>
            <vs-col vs-lg="5" vs-sm="5" vs-xs="12" class="mt-1">
              <vs-button class="w-full" @click="refine(nomeCliente, cnpjCliente, proposeDate, status)" icon="search">Buscar</vs-button>
            </vs-col>
            <vs-col vs-lg="2" vs-sm="2" vs-xs="12" class="mt-1">
              <button
                v-if="isAuthorized('PROPOSE_ADD')"
                name="button"
                @click="addPropose()"
                class="ml-3 vs-component vs-button vs-button-primary vs-button-filled includeIcon includeIconOnly vs-radius">
                <feather-icon icon="PlusIcon" svgClasses="w-4 h-4"></feather-icon>
              </button>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </vx-card>

    <vx-card>

      <vs-row>
        <vs-col>
          <label class="font-semibold">Resumo das propostas</label>
        </vs-col>
      </vs-row>
      <vs-row vs-align="center">
        <vs-col vs-lg="5" vs-sm="5" vs-xs="12" class="mt-1">
          <vs-button @click="downloadReport">Download Relatório</vs-button>
        </vs-col>
      </vs-row>

      <vs-table stripe :data="proposes" noDataText="Nenhum registro encontrado." class="mt-4">

        <template slot="thead">
          <th>Status</th>
          <th>Codigo</th>
          <th>Cliente</th>
          <th>CNPJ</th>
          <th>Garantidor</th>
          <th>CNPJ</th>
          <th>Operação</th>
          <th>Volume</th>
          <th>Status</th>
          <th>Data da Análise</th>
          <th>Área Responsável</th>
          <vs-tooltip text="Tempo restante para atender SLA">
            <th>Tempo</th>
          </vs-tooltip>
          <th>Usuário</th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(row, indextr) in data"  >
            <td>
              <vs-button disabled size="small" v-if="row.lastSla && statusSlaColor(row.lastSla)"
               :color="statusSlaColor(row.lastSla)" style="opacity:1">
                {{row.lastSla.statusSla | formatStatusSla}}
              </vs-button>
            </td>
            <td>
              <a
                :href="$router.resolve({ path: '/propose/' + row.guid }).href"
                class="vx-logo cursor-pointer mx-auto flex items-center text-primary"
                >
                {{row.codigo}}
              </a>
            </td>
            <td>
              <a
                :href="$router.resolve({ path: '/propose/' + row.guid }).href"
                class="vx-logo cursor-pointer mx-auto flex items-center text-primary"
                >
                {{row.config.client.name}}
              </a>
            </td>
            <td>
              {{(row.config.client.cnpjAlfa || row.config.client.cnpj) | formatCnpj}}
            </td>
            <td>
              {{row.config.guarantor.name}}
            </td>
            <td>
              {{(row.config.guarantor.cnpjAlfa || row.config.guarantor.cnpj) | formatCnpj}}
            </td>
            <td>
              {{row.config.operationType | formatOperationType}}
            </td>
            <td>
              {{row.config.totalAmount | toDecimal}}
            </td>
            <td>
              {{ row.status | formatProposeStatus}}
            </td>
            <td>
              {{row.createdAt | formatDate}}
            </td>
            <td>
              {{ row.lastSla.statusDescription }}
            </td>
            <td>
              {{ workedTime(row.lastSla) | formatHour}}
            </td>
            <td>
              <span v-if="row.lastSla.userAssigned">{{ row.lastSla.userAssigned.email }}</span>
              <span v-if="row.lastSla.userAssigned && !isCurrentUserAssigned(row) && row.assignable">
                <br><a  role="button" style="cursor: pointer" @click="assignUser(row)">Alterar</a>
              </span>
              <a v-if="row.lastSla.userAssigned == null && row.status !== 'DONE' && row.assignable"
                role="button" style="cursor: pointer" @click="assignUser(row)">Assinar</a>
            </td>
          </vs-tr>
        </template>

      </vs-table>

      <div class="my-5">
        <vs-pagination
          v-model="page"
          :total="totalPages">
        </vs-pagination>
      </div>

    </vx-card>

  </div>
</template>

<script>
import axios from 'axios'
import CnpjInput from '../../components/CnpjInput'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/pt-br'
import UserAuthorization from "@/mixins/UserAuthorization";
//import { Promise as $router } from "ag-grid-community";

export default {
  computed: {
  },
  mixins:[UserAuthorization],
  components: {
    CnpjInput,
    DatePicker
  },
  data () {
    return {
      nomeCliente: null,
      cnpjCliente: null,
      proposeDate: null,
      status: '',
      statusOptions: [],
      proposes: [],
      page: 1,
      totalPages: 0
    }
  },
  watch: {
    page () {
      this.loadProposes()
    }
  },
  beforeMount () {
    this.loadProposes()
    this.loadProposeStatus()
  },
  mounted () {
    // this.refresh()
  },
  methods: {

    refresh () {
      this.loadProposes()
    },

    async loadProposes () {
      await axios.get(`${process.env.VUE_APP_API  }/api/v1/propose`,
        {
          params: {
            nomeCliente: this.nomeCliente,
            cnpjCliente: this.cnpjCliente,
            date: this.date,
            status: this.status,
            page: this.page - 1
          }
        })
        .then((response) => {
          this.proposes = response.data.content
          this.totalPages = response.data.totalPages
          this.proposes.forEach((propose) => {
            this.checkPerfilUser(propose)
          })
        })

    },
    async loadProposeStatus () {
      await axios.get(`${process.env.VUE_APP_API}/api/v1/propose/status`)
        .then((response) => {
          this.statusOptions = response.data
        })
    },
    view (row) {
      this.$router.push({path: `/propose/${  row.guid}`})
    },
    addPropose () {
      this.$router.push({path: '/propose-add'})
    },
    refine (nomeCliente, cnpjCliente, proposeDate, status) {
      this.nomeCliente = nomeCliente
      this.cnpjCliente = cnpjCliente
      this.proposeDate = proposeDate
      this.status = status
      this.page = 1
      this.refresh()
    },
    clearFilter () {
      this.nomeCliente = null
      this.cnpjCliente = null
      this.proposeDate = ''
      this.status = ''
      this.page = 1
      this.refresh()
    },
    statusDescription(propose) {
      if (propose.currentProposeSla && propose.currentProposeSla.statusDescription) {
        return propose.currentProposeSla.statusDescription
      } else
        return propose.status

    },
    workedTime(currentProposeSla) {
      if (currentProposeSla && currentProposeSla.statusSla != 'DONE') {
        return currentProposeSla.timeToFinish
      }
    },
    statusSlaColor(currentProposeSla) {
      if (currentProposeSla && currentProposeSla.statusSla){
        if (currentProposeSla.statusSla == 'LATE') {
          return "danger"
        } else if (currentProposeSla.statusSla == 'WARNING') {
          return "warning"
        } else if (currentProposeSla.statusSla == 'DONE') {
          return "success"
        }
      }
    },
    statusSla(currentProposeSla) {
      if (currentProposeSla && currentProposeSla.statusSla){
        return currentProposeSla.statusSla
      }
    },
    checkPerfilUser(propose) {
      if (propose && propose.guid){
        axios.get(`${process.env.VUE_APP_API  }/api/v1/propose/${propose.guid}/check-perfil`)
        .then((response) => {
          propose.assignable = response.data
        }).catch(ex => {
          this.$vs.notify({
            color:'danger',
            text:ex.response ? ex.response.data : ex.message
          })
          propose.assignable = false
        })
      }
      propose.assignable = false
    },
    assignUser(propose) {
      if (localStorage.currentUser) {
        var currentUser = JSON.parse(localStorage.currentUser)
        if (!this.isCurrentUserAssigned(propose) && propose.userAssigned) {
          this.$vs.dialog({
            type: 'confirm',
            color: 'danger',
            title: 'Alterar usuário',
            text: 'A proposta está em análise por outro usuário. Deseja mesmo alterar?',
            accept: this.promptChangeAssignedUser,
            parameters: [propose, currentUser],
            acceptText: 'Ok'
          })
        } else if (!propose.userAssigned || propose.userAssigned.email == null) {
          this.changeAssignedUser(propose, currentUser)
        }
      }
    },
    isCurrentUserAssigned(propose) {
      if (localStorage.currentUser && propose.userAssigned) {
        var currentUser = JSON.parse(localStorage.currentUser)
        if (currentUser.email == propose.userAssigned.email) {
          return true
        }
      }
      return false
    },
    promptChangeAssignedUser(parameters) {
      this.changeAssignedUser(parameters[0], parameters[1])
    },
    changeAssignedUser(propose, currentUser) {
      axios.post(`${process.env.VUE_APP_API  }/api/v1/propose-sla-assign`,
        {
          proposeId: propose.guid,
          userEmail: currentUser.email
        })
        .then(() => {
          this.$vs.notify({
            color:'success',
            text:'Usuário da proposta alterado'
          })
          this.refresh()
        })
        .catch(ex => {
          this.$vs.notify({
            color:'danger',
            text:ex.response ? ex.response.data : ex.message
          })
          this.refresh()
        })
    },

    downloadReport() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/propose/report`,
        {
          responseType: 'blob'
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const filename = response.headers["x-suggested-filename"];
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        })
    },
  }
}

</script>
